import { Currency, LegalEntityCountry } from '@seapoint/server/enums';
import { isValidIBAN } from 'ibantools';

import { z } from 'zod';

// Bank Information Validation Schema
export const bankInformationBaseSchema = z.object({
  country: z.nativeEnum(LegalEntityCountry, { message: 'Country is required' }),
  currency: z.nativeEnum(Currency, { message: 'Currency is required' }),
  accountNumber: z
    .string()
    .trim()
    .max(8, 'Account number must be 8 digits or less')
    .transform((val) => val.replace(/[^0-9]/g, ''))
    .optional()
    .nullable(),
  sortCode: z
    .string()
    .trim()
    .max(8, 'Sort code must be 6 digits or less')
    .transform((val) => val.replace(/[^0-9]/g, ''))
    .optional()
    .nullable(),
  iban: z
    .string()
    .trim()
    .transform((val) => val.split(' ').join(''))
    .optional()
    .nullable()
    .refine((val) => !val || isValidIBAN(val), {
      message: 'A valid IBAN is required',
    }),
});

export type BankInformationFormValues = z.infer<typeof bankInformationBaseSchema>;
